import { useDelete } from '@refinedev/core';
import { User } from '../types';

export function useDeleteUser() {
  const { mutateAsync, error, isLoading, reset } = useDelete<User>();

  const deleteUser = async (id: string) => {
    return mutateAsync({
      resource: 'users',
      id,
    });
  };

  return {
    deleteUser,
    error,
    isLoading,
    reset,
  };
}
